<template>
  <div class="details room">
    <p><pre>{{ room }}</pre></p>
  </div>
</template>

<script>
import { API_URL } from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: ['id'],
  data() {
    return {
      room: {},
    }
  },
  computed: {
    ...mapGetters(['details']),
  },
  created() {
    const room = this.axios.get(API_URL + '/rooms/' + this.id);
    this.setProgress(false);
    this.room = room.data;
  }
}
</script>

<style lang="scss">
.details.room {
  padding: 12px;
  > table {
    > tbody {
      > tr {
        td:first-child {
          width: 120px;
        }
        td:not(:first-child) {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
